<div id="login-modal">
  <div class="login-form-container">
    <div class="login-form">
      <div>
        <img class="ms-logo" src="/img/header.jpg" />
      </div>
      @if(!loggingIn){
      <h2>Sign in</h2>
      <input type="text" [(ngModel)]="username" (keydown.enter)="login()" class="ms-username" placeholder="Email, phone, or Skype">
      <a id="cantAccessAccount" name="cannotAccessAccount" href="https://login.microsoftonline.com/e875b9bb-b3ee-4961-b756-3aad14e43814/oauth2/v2.0/authorize?client_id=66f7dbae-faf5-40cc-b51b-0e973635921a&scope=User.Read%20openid%20profile%20offline_access&redirect_uri=http%3A%2F%2Flocalhost%3A4200&client-request-id=019622a8-5b7d-7b13-aed5-63af34ae0704&response_mode=fragment&client_info=1&nonce=019622a8-5b7e-7df1-94af-d985513733ff&state=eyJpZCI6IjAxOTYyMmE4LTViN2QtNzcwNi05MzJmLWYxNzNjNGZlOGFhOCIsIm1ldGEiOnsiaW50ZXJhY3Rpb25UeXBlIjoicmVkaXJlY3QifX0%3D&x-client-SKU=msal.js.browser&x-client-VER=4.10.0&response_type=code&code_challenge=MdpB5WQpoKSZ9kFaQ_-o0lQhkH5g9eMblKUgKaPnY2A&code_challenge_method=S256#">Can’t access your account?</a>
      <div class="text-right btn-container"><button (click)="login()" class="ms-button" style="width:100px;">Next</button></div>
      }
      @else{
        <h2>Signing in...</h2>
        <!-- <div style="margin:auto; margin-top:40px; padding:0px; text-align:center;"><mat-spinner></mat-spinner></div> -->
        <div style="margin-top:20px;"><span class="ms-loader"></span></div>
        

      <!-- <div style="display:flex; flex-direction:column; align-items:center; gap:80px">
        <h2>Singing In With Microsoft</h2>
        <mat-spinner></mat-spinner>
      </div> -->
      }
    </div>
  </div>
</div>

